// API Configuration
// In local dev, point the API at the *same host* the page is served from
// (localhost vs 127.0.0.1). Mixing the two makes the session cookie cross-site,
// so SameSite=Lax drops it and the user gets logged out on every refresh.
function resolveApiBaseUrl() {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return `http://${host}:3001`;
  // Production (and any other host): same-origin relative URLs.
  return process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : '';
}

const config = {
  apiBaseUrl: resolveApiBaseUrl(),
};

console.log('🔧 API Config:', {
  apiBaseUrl: config.apiBaseUrl,
  isWindow: typeof window !== 'undefined',
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'N/A',
  nodeEnv: process.env.NODE_ENV
});

export default config;
